import React, { useState, useEffect } from "react";
import { Row, Col, Button, Modal } from "react-bootstrap";
import "../equipamentsBrands.css";
import api from "../../../services/api";
import Fontawesome from "../../fontawesome/fontawesome";
import { Prefix } from "../../../services/prefix";
import Loading from "../../loader/loading";
import Swal from "sweetalert2";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { mutate as mutateGlobal } from "swr";
import Schema from "./schema";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import { useStyles } from "../../buttons/AddButtonStyle";
import { mutate as GlobalMutate } from "swr";
import { ModalContainer } from "../../../style/stylesModals";
import { CustomButton, TextButton } from "../../../style/stylesButton";

const IndexAddEquipamentBrand = (props) => {
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [initialState, setInitialState] = useState({
    name: "",
    active: 1,
  });
  const [registerData, setRegisterData] = useState(initialState);

  let valueSearch = !props.search ? "" : props.search;

  const handleClose = () => {
    setShow(false);
    setRegisterData(initialState);
  };
  const handleShow = () => {
    setShow(true);
  };

  function HandleRegister(values) {
    setLoader(true);
    api
      .post(Prefix.replace(/[\\"]/g, "") + "/equipment-brands", values)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Uow!",
          text: "Cadastro realizado com sucesso!",
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: "Fechar",
          cancelButtonText: "Novo Cadastro",
          allowOutsideClick: false,
        }).then((result) => {
          if (!result.isConfirmed) {
            setShow(true);
          }
        });
        setLoader(false);
        setRegisterData(initialState);
        setShow(false);
        GlobalMutate(
          Prefix.replace(/[\\"]/g, "") +
            "/equipment-brands?per_page=" +
            props.perPage +
            "&page=" +
            props.pageExact +
            "&search=" +
            valueSearch +
            "&order_by=" +
            props.orderBy +
            "&order=" +
            props.order
        );
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err.response.data.message,
          confirmButtonText: "Tentar novamente",
        });
        setLoader(false);
      });
  }

  const HandleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setRegisterData({ ...registerData, [name]: value });
  };

  const classes = useStyles();

  return (
    <>
      {show === false && (
        <Fab className={classes.fab} onClick={handleShow}>
          <AddIcon className={classes.icon} />
        </Fab>
      )}
      <ModalContainer
        show={show}
        size={props.modalSize}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title><h3>{props.titleLabel}</h3></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loader && <Loading />}
          <Formik
            initialValues={registerData}
            validationSchema={Schema}
            onSubmit={HandleRegister}
            enableReinitialize
          >
            {({ values }) => (
              <Form>
                <Row>
                  <Col>
                    <div className="formStep">
                      <div className="labelForm">
                        <label className="important">Nome da Marca</label>
                      </div>
                      <Field
                        type="text"
                        placeholder="Digite um nome"
                        name="name"
                        onChange={HandleChange}
                      />
                      <ErrorMessage
                        name="name"
                        component="span"
                        className="errorMessages"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className="d-flex justify-content-center">
                    <CustomButton type="submit">
                      <TextButton> Adicionar </TextButton>
                    </CustomButton>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </ModalContainer>
    </>
  );
};
export default IndexAddEquipamentBrand;
